import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";


let config = {
    
  apiKey: "AIzaSyDtvdEBmhZnzomLB2R3jy0zb-9rDnVIPbQ",
  authDomain: "secret-chat-box.firebaseapp.com",
  projectId: "secret-chat-box",
  storageBucket: "secret-chat-box.appspot.com",
  messagingSenderId: "466467615569",
  appId: "1:466467615569:web:cfb496695a77237128d970",
  measurementId: "G-8VMKYFTBZX",
};

firebase.default.initializeApp(config);
const auth = firebase.auth();
const db = firebase.firestore();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { auth, firebase, db, googleAuthProvider };
